module.exports = __webpack_public_path__ + "static/kvm_3.edc99f02.jpg";